module.exports = __webpack_public_path__ + "img/aspect-ratio-9-16.e88f8998.svg";